import { titleCapitalize } from "helpers/text"
import { ALL_CODE } from "helpers/service"
import { Tuple } from "../Interfaces"
import { FiltersType } from "components/Shared/GlobalFilter/context/interfaces"
import { Interval } from "../PhronesisCalendar/PhronesisCalendar.domain"
import { mapGlobalFilters } from "../GlobalFilter/utils"
import * as GlobalFilters from "../GlobalFilter/constants"
import { SinglePeriod } from "components/Labs/CrossSelling/interfaces"
import { RequestParameters } from "./interfaces"

type mapModuleFiltersProps = {
	filters: FiltersType
	calendarDates: Interval | SinglePeriod
}

const mapModuleFilters = ({
	filters,
	calendarDates,
}: mapModuleFiltersProps): RequestParameters => {
	const globalFiltersMapped = mapGlobalFilters(
		filters,
		GlobalFilters.globalFiltersMapBackendConfig
	)

	return {
		...globalFiltersMapped,
		...calendarDates,
	} as RequestParameters
}

const capitalizeTuple = (data: Tuple[]): Tuple[] => {
	return data.map((object) => ({
		...object,
		name: titleCapitalize(object.name),
	}))
}

const allOptionWasAlreadySelected = (
	options: Array<Tuple>,
	allOptions: Array<Tuple>
): Array<Tuple> => {
	if (options.some((option) => option.code === ALL_CODE)) {
		return []
	}
	return allOptions
}

const optionsWithAll = (
	selected: Tuple,
	options: Array<Tuple>,
	allOptions: Array<Tuple>
): Array<Tuple> => {
	if (selected.code && selected.code === ALL_CODE) {
		return allOptionWasAlreadySelected(options, allOptions)
	}
	return optionsWithoutAll(
		selected,
		options.filter((option) => option.code !== ALL_CODE)
	)
}

const optionsWithoutAll = (
	selected: Tuple,
	options: Array<Tuple>
): Array<Tuple> => {
	if (!options.some((option) => option.code === selected.code)) {
		return [...options, selected]
	}
	return options.filter((option) => option.code !== selected.code)
}

const optionsSelected = (
	selected: Tuple,
	options: Array<Tuple>,
	allOptions: Array<Tuple>,
	allOption: boolean | undefined
): Array<Tuple> => {
	if (allOption) {
		return optionsWithAll(selected, options, allOptions)
	}
	return optionsWithoutAll(selected, options)
}

export { capitalizeTuple, optionsSelected, mapModuleFilters }
